import styled from "styled-components";
import { LeftStars, RightStars } from "@assets";
export const RootContainer = styled.div`
	position: relative;
	margin: 0;
	/* padding: 20px 16px; */
	/* .ant-table-wrapper {
    margin: 82px 16px 24px 16px;
  } */
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
`;

export const OuterDiv = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 15px 20px;
	background-color: #f8eeff;
	border-top: 1px solid white;
	border-bottom: 1px solid white;
`;

export const InfoText = styled.span`
	color: ${(props) => (props.isName !== true ? "#9B92BB" : "#5D5189")};
	font-size: ${(props) => (props.isName !== true ? "16" : "14")};
	font-weight: 400;
	line-height: 24.19px;
`;

export const DateText = styled.span`
	color: #5d5189;
	font-size: 16px;
	line-height: 21px;
	font-weight: 400;
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;
`;

export const IndexNumber = styled.div`
	color: #f9f9f9;
	display: flex;
	gap: 7px;
`;

export const Number = styled.div`
	font-weight: 400;
	font-size: 16px;
	color: #5d5189;
`;

export const FriendListWrapper = styled.div`
	/* border-radius: 16px;
	background-color: #1e1a1b;
	margin: 10px 20px;
	padding: 10px;
	max-height: 700px; */
	/* background-color: red; */
`;

export const TitleDiv = styled.div`
	height: 87px;
	background-color: #49028e;
	border-bottom-left-radius: 16px;
	border-bottom-right-radius: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	margin-bottom: 10px;
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 5px;
	padding: 3px 0;
`;

export const LeftStarsGroup = styled(LeftStars)`
	position: absolute;
	left: 10px;
`;

export const RightStarsGroup = styled(RightStars)`
	position: absolute;
	right: 10px;
`;

export const Title = styled.p`
	font-weight: 500;
	font-size: 16px;
	line-height: 24.17px;
	color: #ffffff;
`;

export const SubTitle = styled.p`
	font-size: 12px;
	font-weight: 400;
	line-height: 18.8px;
	color: #ffffff;
`;

export const NoFriendListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	height: 70vh;
`;

export const NoFriendText = styled.p`
	color: #5d5189;
	font-weight: 400;
	font-size: 16px;
`;
